import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import DropdownIndicator from './DropdownIndicator'
import Option from './Option'
import styles from './styles'

const Select = ({
	options,
	defaultValue,
	value,
	onChange,
	isSearchable,
	useAlternativeStyle,
	...rest
}) => (
	<ReactSelect
		components={{ Option, DropdownIndicator }}
		defaultValue={defaultValue}
		value={value}
		options={options}
		className={useAlternativeStyle ? 'select--alternative' : ''}
		styles={{
			...styles.defaultStyle,
			...(useAlternativeStyle ? styles.alternativeStyle : {}),
		}}
		isSearchable={isSearchable}
		onChange={onChange}
		// menuPortalTarget={document.getElementById('root')}
		{...rest}
	/>
)

Select.propTypes = {
	options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object]))
		.isRequired,
	value: PropTypes.oneOfType([PropTypes.object]),
	defaultValue: PropTypes.oneOfType([PropTypes.object]),
	onChange: PropTypes.func,
	isSearchable: PropTypes.bool,
	useAlternativeStyle: PropTypes.bool,
}

Select.defaultProps = {
	value: null,
	defaultValue: null,
	onChange: null,
	isSearchable: false,
	useAlternativeStyle: false,
}

export default Select
